import { fetchCurrentUserThunk } from '@/redux/slices/currentUserSlice'
import { fetchTogglesThunk, switchUserThunk } from '@/redux/slices/sessionSlice'
import { resetStore, useAppDispatch, useAppSelector } from '@/redux/store'
import { isFulfilled } from '@reduxjs/toolkit'
import { router } from 'expo-router'
import { useCallback } from 'react'

export function useSwitchTeam() {
  const dispatch = useAppDispatch()
  const billingAccountUsers = useAppSelector(state => state.currentUser.user?.billingAccountUsers)

  return useCallback(
    async (userId: string) => {
      const user = billingAccountUsers?.find(u => u.id === userId)
      if (!user?.apiToken) {
        router.push('/profile/switchUser')
        return
      }
      const result = await dispatch(switchUserThunk({ userToken: user.apiToken }))
      if (isFulfilled(result)) {
        dispatch(resetStore())
        dispatch(fetchCurrentUserThunk())
        dispatch(fetchTogglesThunk())
        if (router.canDismiss()) router.dismissAll()
      }
    },
    [dispatch, billingAccountUsers]
  )
}
